module.exports = __webpack_public_path__ + "img/ttl_step_02.7648820f.svg";